{
  "competition_details": "Competition Details",
  "view_coming_soon": "Competition View Coming Soon",
  "coming_soon": "Coming Soon",
  "player_view_description": "This feature will allow you to view competition details, register for competitions, and track your results.",
  "view": {
    "public": "Public",
    "live": "Live",
    "date": "Date",
    "type": "Type",
    "description": "Description",
    "participants": "Participants",
    "min_players": "Min: {{count}}",
    "ideal_players": "Ideal: {{count}}",
    "features_coming_soon": "Registration and leaderboard features coming soon",
    "register": "Register",
    "registration_period": "Registration Period",
    "start_times": "Start Times",
    "no_participants": "No participants yet",
    "round": "Round",
    "no_start_times": "No tee times have been set yet",
    "add_to_calendar": "Add to calendar",
    "notPublic": "Not public",
    "load_failed": "Event not found or its details could not be loaded."
  },
  "types": {
    "SINGLE": "Individual",
    "TEAM": "Team Competition",
    "EVENT": "Event",
    "WEEKLY": "Weekly Competition",
    "MATCHPLAY": "Match play"
  },
  "typeDescriptions": {
    "SINGLE": "Individual competition where each player plays their own score",
    "TEAM": "Team competition where teams of 2-4 players compete against each other.\n\nGame formats: Greensome, Foursome, Scramble, Best Ball and Irish Rumble",
    "WEEKLY": "Weekly competition where players can submit multiple scores and the best scores count towards the final result",
    "EVENT": "Other event without scoring. For example, pro's course, annual meeting or club trip",
    "MATCHPLAY": "Match-type competition where players or teams play against each other in bracket or league format (coming soon)"
  },
  "list": {
    "search_placeholder": "Search competitions...",
    "no_competitions_found": "No competitions found",
    "no_competitions_for_search": "No competitions found for \"{{searchTerm}}\" in {{year}}.",
    "no_competitions_for_year": "No competitions found for {{year}}",
    "failed_to_load": "Failed to load competitions",
    "try_again": "Try Again",
    "click_to_edit": "Click to edit competition",
    "create_competition": "Create event",
    "has_waitlist": "Competition has waitlisted participants",
    "public_calendar": "Public calendar",
    "show_older": "Show past",
    "upcoming": "Upcoming",
    "all": "All"
  },
  "table": {
    "start_date": "Date",
    "name": "Name",
    "type": "Type",
    "status": "Status",
    "participants": "Participants",
    "courses": "Courses",
    "tenant": "Club"
  },
  "form": {
    "selectTypeTitle": "Select Competition Type",
    "tabs": {
      "eventInfo": "Event",
      "series": "Series",
      "teams": "Teams",
      "participants": "Participants",
      "rounds": "Rounds",
      "flights": "Flights",
      "results": "Scorecards",
      "scoring": "Scoring",
      "matchplay": "Brackets"
    },
    "fields": {
      "name": "Competition Name",
      "type": "Competition Type",
      "startDate": "Start Date",
      "endDate": "End Date",
      "description": "Description",
      "maxParticipants": "Maximum Participants",
      "registrationOpens": "Registration Opens",
      "registrationCloses": "Registration Closes",
      "min_team_size": "Minimum Team Size",
      "max_team_size": "Maximum Team Size",
      "competitionImage": "Competition image",
      "invitation": "Invitation",
      "maxScoresPerPlayer": "Maximum Scores",
      "countingScores": "Counting Scores",
      "themeColor": "Theme Color",
      "cancellationDeadline": "Cancellation deadline",
      "registrationRestriction": "Allow registration",
      "allowedClubs": "Select clubs",
      "publicDescription": "Public description",
      "chooseThemeColor": "Choose theme color",
      "allowWaitlist": "Allow waitlist",
      "publicUrl": "Public link",
      "tenant": "Customer",
      "liveScoringHiddenHoles": "Hide last holes from live scoring results",
      "participantVisibility": "Participant visibility",
      "publicDescriptionSociety": "Description for members",
      "publicUrlSociety": "Event link",
      "cartWishEnabled": "Show golf cart selection to participant",
      "cartWishInfoText": "Golf cart preference additional info"
    },
    "placeholders": {
      "name": "Enter competition name",
      "description": "Optional description of the competition...",
      "maxParticipants": "e.g., 144",
      "new_competition": "New Competition",
      "searchClubs": "Search club...",
      "selectType": "Select type...",
      "noTenant": "No customer",
      "cartWishInfoText": "E.g. with doctor's certificate only"
    },
    "switches": {
      "publicLabel": "Make competition public",
      "participationLabel": "Enable participant registration",
      "allowTeeSelectionLabel": "Player can select tee set",
      "cancellationLabel": "Cancellation allowed",
      "allowAbnormalTeesLabel": "Allow non-default tees",
      "subCompetitionLabel": "Add team competition",
      "liveScoringEnabledLabel": "Live scoring enabled",
      "publicLabelSociety": "Show to members"
    },
    "hints": {
      "descriptionCounter": "/5000 characters",
      "maxScoresPerPlayer": "How many scores a player can submit",
      "countingScores": "How many best scores will be counted",
      "allowTeeSelection": "If disabled, player plays from the tee set according to their series based on gender",
      "allowTeeSelectionRoundInfo": "This setting is defined at competition level. Edit competition settings to change this.",
      "publicDescriptionHint": "Visible in the public event calendar",
      "publicUrlCopy": "Copy link",
      "publicUrlOpen": "Open in new tab",
      "allowAbnormalTees": "If enabled, the administrator can assign an exceptional tee to a participant",
      "liveScoringHiddenHolesHelp": "Hidden holes will become visible when results are published",
      "publicDescriptionHintSociety": "Visible to members"
    },
    "placeholders_tab": {
      "seriesTitle": "Series Management",
      "seriesDescription": "Series configuration will be available here.",
      "participantsTitle": "Participant Management",
      "participantsDescription": "Participant registration and management will be available here.",
      "roundsTitle": "Rounds Management",
      "roundsDescription": "Rounds management will be available here."
    },
    "actions": {
      "cancel": "Cancel",
      "create": "Create Competition",
      "update": "Update Competition",
      "delete": "Delete Competition",
      "save": "Save Competition",
      "saving": "Saving..."
    },
    "messages": {
      "unsavedChanges": "You have unsaved changes. Don't forget to save your work!",
      "unsaved_cancel_confirm": "Are you sure you want to cancel? Any unsaved changes will be lost."
    },
    "errors": {
      "not_found": "Competition not found",
      "no_permission_edit": "You do not have permission to edit this competition",
      "no_permission_delete": "You do not have permission to delete this competition",
      "failed_to_load": "Failed to load competition details",
      "failed_to_update": "Failed to update competition. Please try again.",
      "failed_to_delete": "Failed to delete competition. Please try again.",
      "invalid_data": "Invalid competition data",
      "duplicate_name_date": "A competition with this name and date already exists",
      "start_date_required": "Start date is required",
      "failed_to_create": "Failed to create event"
    },
    "success": {
      "updated": "Competition \"{{name}}\" updated successfully!",
      "deleted": "Competition \"{{name}}\" deleted successfully"
    },
    "delete_confirm": {
      "header": "Delete Competition",
      "body": "Are you sure you want to delete \"{{name}}\"?\n\nThis action cannot be undone and will permanently remove this competition and all associated data.",
      "button": "Delete Competition"
    },
    "edit": {
      "title": "Edit Competition",
      "failed_to_load_title": "Failed to load competition",
      "back_button": "Back to Competitions"
    },
    "participants": {
      "no_series_created": "No series have been created yet. Create series first to manage participants.",
      "select_series": "Select Series to Manage Participants"
    },
    "name": "Name",
    "name_placeholder": "Enter event name",
    "start_date": "Start date",
    "participation_enabled": "Registration allowed",
    "is_public": "Public",
    "restriction_options": {
      "ALL_PLAYERS": "All players",
      "EBIRDIE_MEMBERS": "Golf Federation members only",
      "HOME_CLUB_MEMBERS": "Home club members only",
      "SELECTED_CLUBS": "Selected clubs only"
    },
    "copy": {
      "title": "Copy event",
      "description": "Create a new event by copying the current one. All series, rounds, and settings will be copied. Participants and scores will not be copied.",
      "button": "Copy",
      "success": "Event \"{{name}}\" copied successfully!",
      "failed": "Failed to copy event"
    },
    "createCompetition": "Create event",
    "cannot_delete_has_participants": "The competition cannot be deleted because it has {{count}} confirmed participants. Please remove the participants first.",
    "matchplayTeamSizeTitle": "Match play — number of players",
    "matchplayTeamSizeHelp": "Select how many players are on one team.",
    "matchplayTeamSizeLabel": "Players per team",
    "matchplayTeamSizeHint": "1 = individual competition, 2 = pair competition (e.g. Foursome, Greensome), 3–4 = team (Scramble).",
    "matchplayTeamSizeBack": "Back",
    "matchplayTeamSizeContinue": "Continue",
    "matchplayTeamSizeOptionTitle": {
      "1": "Individual competition",
      "2": "Pair competition",
      "3": "3-player team",
      "4": "4-player team"
    },
    "matchplayTeamSizeOptionTag": {
      "1": "Match play · Stableford · Stroke play",
      "2": "Foursome · Greensome · Scramble",
      "3": "Scramble",
      "4": "Scramble"
    },
    "visibility_audience_options": {
      "EVERYONE": "Everyone",
      "PARTICIPANTS": "Participants only",
      "HIDDEN": "Hidden"
    },
    "visibility_audience_badge": {
      "EVERYONE": "Everyone",
      "PARTICIPANTS": "Participants",
      "HIDDEN": "Hidden"
    }
  },
  "series": {
    "title": "Series",
    "add_series": "Add Series",
    "edit_series": "Edit Series",
    "create_series": "Create Series",
    "delete_series": "Delete Series",
    "select_series_to_edit": "Select a series to edit",
    "no_series": "No series",
    "no_series_message": "No series have been created for this event yet.",
    "failed_to_load_series": "Failed to load series",
    "series_created_successfully": "Series created successfully",
    "series_updated_successfully": "Series updated successfully",
    "series_deleted_successfully": "Series deleted successfully",
    "save_failed": "Failed to save series",
    "delete_failed": "Failed to delete series",
    "new_series": "New Series",
    "series_details": "Series Details",
    "confirm_delete_series": "Are you sure you want to delete this series?",
    "form": {
      "name": "Series Name",
      "name_placeholder": "e.g. Men's A-Series",
      "gender": "Gender",
      "gender_help": "Select genders that can participate in this series",
      "age_min": "Minimum Age",
      "age_max": "Maximum Age",
      "age_range": "Age Restriction",
      "hcp_min": "Minimum Handicap",
      "hcp_max": "Maximum Handicap",
      "hcp_range": "Handicap Restriction",
      "max_participants": "Maximum Participants",
      "min_team_size": "Minimum Team Size",
      "max_team_size": "Maximum Team Size",
      "men_max_handicap": "Men's maximum handicap (SAT)",
      "women_max_handicap": "Women's maximum handicap (SAT)",
      "handicap_factor": "Handicap factor",
      "basic_info_title": "Basic Information",
      "handicap_settings_title": "Handicap Settings",
      "team_handicap_percentages": "Team Handicap Percentages",
      "team_handicap_percentages_help": "Percentages are distributed by handicap, lowest first",
      "player_percentage": "Player {{number}}",
      "cut_after_round": "CUT after round",
      "cut_line": "CUT qualifiers",
      "result_type": "Primary result type",
      "allow_waitlist": "Allow waitlist",
      "payment_mode": {
        "label": "Online payment",
        "not_in_use": "Not in use",
        "compulsory": "Mandatory",
        "voluntary": "Optional",
        "not_available": "Payment options are not available.",
        "not_available_contact": "Please contact support."
      },
      "team_size": "Team size",
      "team_size_max": "Players per team (max)",
      "team_size_min": "Players per team (min)",
      "allow_incomplete_teams": "Allow incomplete teams",
      "draw_decision": "Tiebreaker",
      "secondary_result_type": "Secondary score type",
      "secondary_draw_decision": "Tiebreaker",
      "no_secondary": "No secondary"
    },
    "display": {
      "age_range": "Age: {{range}}",
      "hcp_range": "HCP: {{range}}",
      "max_participants": "Max: {{count}}",
      "current_participants": "{{current}}/{{max}} participants",
      "participants_count": "{{count}} participants",
      "full": "Full",
      "all_genders": "All",
      "no_constraints": "No restrictions"
    },
    "cannot_delete_has_participants": "Cannot delete series because it has {{count}} confirmed participants. Please remove the participants first.",
    "drawDecisions": {
      "SHARED_POSITION": "Shared position",
      "MATHEMATICAL": "Mathematical",
      "SLOPE_HANDICAP": "Slope handicap",
      "EXACT_HANDICAP": "Exact handicap"
    },
    "match_play_description": "Set up and manage match play for this series. Create a bracket, define matchups and record match results.",
    "configure_match_play": "Configure bracket and matches",
    "tabs": {
      "general": "General",
      "tees": "Tees"
    },
    "tees": {
      "title": "Series tee settings",
      "empty_no_rounds": "Please create at least one round first",
      "empty_no_rounds_help": "Series-specific tees require a round with a course and tee sets.",
      "go_to_rounds": "Go to rounds",
      "column": {
        "mens_override": "Men's tee",
        "womens_override": "Women's tee"
      },
      "use_round_default": "Use round default",
      "save": "Save tee settings",
      "saved_success": "Series tee settings saved",
      "save_failed": "Failed to save tee settings",
      "row": {
        "round_label": "ROUND",
        "default_suffix": "(default)"
      }
    }
  },
  "rounds": {
    "title": "Rounds",
    "add_round": "Add Round",
    "edit_round": "Edit Round",
    "create_round": "Create Round",
    "delete_round": "Delete Round",
    "no_rounds": "No rounds",
    "no_rounds_message": "No rounds have been created for this event yet.",
    "loading_rounds": "Loading rounds...",
    "failed_to_load_rounds": "Failed to load rounds",
    "round_created_successfully": "Round created successfully",
    "round_updated_successfully": "Round updated successfully",
    "round_deleted_successfully": "Round deleted successfully",
    "failed_to_save_round": "Failed to save round",
    "failed_to_delete_round": "Failed to delete round",
    "confirm_delete_round": "Are you sure you want to delete this round?",
    "new_round": "New Round",
    "round_details": "Round Details",
    "no_courses": "No courses configured",
    "form": {
      "date": "Round Date",
      "play_type": "Play type",
      "courses": "Courses",
      "course": "Course",
      "add_course": "Add Course",
      "remove_course": "Remove Course",
      "select_course": "Select Course",
      "select_course_placeholder": "Choose a course...",
      "course_color": "Course Color",
      "course_color_placeholder": "e.g., Red, Blue, Yellow",
      "start_hole": "Start Hole",
      "end_hole": "End Hole",
      "default_mens_tee": "Default Men's Tee",
      "default_womens_tee": "Default Women's Tee",
      "select_tee": "Select tee...",
      "starting_arrangement": "Starting Arrangement",
      "missing-course": "At least one course must be specified in the round details",
      "counting_scores_per_team": "Scores per team",
      "time_schedule_template": "Pace of Play Template",
      "no_time_template": "No pace of play template",
      "no_templates_for_course": "No schedule templates have been defined for this course.",
      "handicap_settings_title": "Handicap Settings",
      "men_max_handicap": "Men's Maximum Handicap (SAT)",
      "women_max_handicap": "Women's Maximum Handicap (SAT)",
      "handicap_factor": "Handicap Factor",
      "team_handicap_percentages": "Team Handicap Percentages",
      "player_percentage": "Player {{number}}",
      "affects_handicaps": "Affects handicaps",
      "automatically_send_scores": "Send scores automatically",
      "ebirdie_settings_title": "eBirdie Settings",
      "select_play_type_placeholder": "Select play type...",
      "hints": {
        "maxHandicap": "MAH (Maximum Allowed Handicap) limits the handicap before slope handicap calculation. E.g. if a player's handicap is 42.0 and MAH = 36.0, handicap 36.0 is used in the calculation. Leave empty for no limit.",
        "handicapFactor": "The slope handicap is multiplied by the handicap factor BEFORE rounding.",
        "teamHandicapPercentages": "Percentages are distributed according to handicap, lowest handicap first. E.g. Greensome: 60% / 40%. Each player's personal slope handicap is multiplied by the coefficient, after which the handicaps are summed BEFORE rounding",
        "mensTeeRequired": "The series includes male players — a default men's tee is required for draw slope calculation.",
        "womensTeeRequired": "The series includes female players — a default women's tee is required for draw slope calculation.",
        "affects_handicaps": "When enabled, the round's scores are eligible for eBirdie handicap submission.",
        "automatically_send_scores": "Handicaps will be submitted automatically at {{time}}",
        "automatically_send_scores_disabled": "Enable 'Affects handicaps' to use automatic submission",
        "limitTeamHandicapToMinSlope": "When enabled, the team's calculated handicap cannot be higher than the slope handicap of the team's best player. The handicap is limited to the lowest individual player's slope handicap."
      },
      "round_basics_title": "Round details",
      "course_card_title": "Course {{number}}",
      "schedule_section_title": "Target schedule",
      "limit_team_handicap_to_min_slope": "Limit team handicap to lowest individual handicap",
      "course_library_group": "My courses",
      "course_catalog_group": "All courses",
      "course_search_placeholder": "Search for a course...",
      "course_import_failed": "Failed to add course",
      "course_unavailable": "Course is no longer available"
    },
    "course_config": {
      "start_time": "Start Time",
      "start_interval": "Start Interval (minutes)",
      "players_in_flight": "Players in flight",
      "teams_in_flight": "Teams in flight"
    },
    "starting_arrangements": {
      "one_tee": "One Tee",
      "two_tees": "Two Tees",
      "shotgun": "Shotgun"
    },
    "display": {
      "default_tees": "Men: {{menTee}}, Women: {{womenTee}}",
      "multi_course": "{{count}} Courses"
    },
    "cannot_delete_has_results": "Cannot delete round because it has recorded scores."
  },
  "registration": {
    "register_for_series": "Register for Series",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email",
    "phone": "Phone Number",
    "gender": "Gender",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_other": "Other",
    "birth_year": "Birth Year",
    "handicap_index": "Handicap Index",
    "tee_set": "Tee Set",
    "preferred_start_time": "Preferred Start Time",
    "no_preference": "No preference",
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Evening",
    "notes": "Notes",
    "notes_placeholder": "Any special requests or information...",
    "accept_terms": "I accept the registration terms",
    "register": "Register",
    "registering": "Registering...",
    "registration_confirmed": "Registration confirmed!",
    "added_to_waitlist": "Added to waitlist",
    "registration_failed": "Registration failed",
    "registration_full_waitlist": "This series is full. You will be added to the waitlist.",
    "team_size_info": "This is a team event. Teams must have {{min}}-{{max}} players. Multi-player support coming soon.",
    "team_name": "Team Name",
    "team_name_placeholder": "Enter team name...",
    "team_size_requirement": "Team must have {{min}}-{{max}} players",
    "player_number": "Player {{number}}",
    "participant_info": "Participant Information",
    "add_player": "Add Player",
    "errors": {
      "series_required": "Series is required",
      "terms_required": "Please accept the terms to continue",
      "generic": "Registration failed. Please try again.",
      "first_name_required": "First name is required",
      "last_name_required": "Last name is required",
      "email_required": "Email is required",
      "email_invalid": "Invalid email address",
      "phone_required": "Phone number is required",
      "gender_required": "Gender is required",
      "birth_year_required": "Birth year is required",
      "handicap_required": "Handicap is required",
      "handicap_invalid": "Handicap must be between -10.0 and 54.0",
      "tee_set_required": "Tee set selection is required",
      "min_participants": "Team must have at least {{min}} players",
      "max_participants": "Team can have at most {{max}} players",
      "unsaved_participants": "Please save all players before submitting registration"
    },
    "status": {
      "confirmed": "Confirmed",
      "waitlisted": "Waitlisted",
      "withdrawn": "Withdrawn"
    },
    "gender_not_specified": "Not specified",
    "start_time_preference": "Tee time preference",
    "start_time_preference_none": "No preference",
    "start_time_preference_early": "Early",
    "start_time_preference_late": "Late"
  },
  "my_participations": {
    "title": "My Registrations",
    "no_participations": "You haven't registered for any competitions yet.",
    "browse_competitions": "Browse Competitions",
    "failed_to_load": "Failed to load registrations",
    "registered_at": "Registered",
    "waitlist_position": "Waitlist position",
    "view_competition": "View",
    "withdraw": "Withdraw",
    "withdrawal_successful": "Withdrawal successful",
    "withdrawal_failed": "Withdrawal failed",
    "withdraw_confirmation_title": "Withdraw Registration",
    "withdraw_confirmation_message": "Are you sure you want to withdraw from this competition?"
  },
  "admin": {
    "capacity_exceeded": "Capacity exceeded",
    "capacity_warning_competition": "Competition is full ({{current}}/{{max}} confirmed)",
    "capacity_warning_series": "Series \"{{seriesName}}\" is full ({{current}}/{{max}} confirmed)",
    "admin_capacity_choice_prompt": "Would you like to add the participant to the waitlist or confirm participation bypassing the capacity limit?",
    "add_to_waitlist": "Add to waitlist",
    "add_as_confirmed_bypass": "Confirm (bypass limit)",
    "participation_management": "Participation Management",
    "confirmed": "Confirmed",
    "waitlisted": "Waitlisted",
    "withdrawn": "Withdrawn",
    "disqualified": "Disqualified",
    "status_confirmed": "Participants",
    "status_waitlisted": "Waitlisted",
    "status_withdrawn": "Withdrawn",
    "status_pending": "Pending Payment",
    "search_by_name": "Search by name...",
    "participant": "Participant",
    "email": "Email",
    "handicap": "Handicap",
    "status": "Status",
    "registered_at": "Registered",
    "actions": "Actions",
    "no_participations": "No participations",
    "confirm": "Confirm",
    "confirm_participation_message": "Are you sure you want to confirm this participation?",
    "move_to_waitlist": "Move to Waitlist",
    "refresh_data": "Refresh Data",
    "disqualify": "Disqualify",
    "refresh_all": "Refresh All",
    "participation_confirmed": "Participation confirmed",
    "moved_to_waitlist": "Moved to waitlist",
    "participant_refreshed": "Participant data refreshed",
    "all_participants_refreshed": "All participants refreshed",
    "participant_disqualified": "Participant disqualified",
    "confirm_failed": "Confirmation failed",
    "move_to_waitlist_failed": "Move to waitlist failed",
    "refresh_failed": "Data refresh failed",
    "refresh_all_failed": "Refresh all failed",
    "disqualify_failed": "Disqualification failed",
    "disqualification_reason_prompt": "Enter disqualification reason:",
    "series": "Series",
    "add_participation": "Add Participant",
    "batch_actions": "Actions",
    "batch_actions_disabled": "Select participants first",
    "batch_withdraw": "Remove Participations",
    "batch_confirm": "Move to Participants",
    "batch_move_to_waitlist": "Move to Waitlist",
    "batch_withdraw_confirm_title": "Remove Selected Participations",
    "batch_withdraw_confirm_body": "Are you sure you want to remove {{count}} participations?",
    "participations_withdrawn": "{{count}} participations removed",
    "participations_confirmed": "{{count}} participations confirmed",
    "participations_moved_to_waitlist": "{{count}} participations moved to waitlist",
    "batch_withdraw_failed": "Removing participations failed",
    "batch_confirm_failed": "Confirming participations failed",
    "batch_move_to_waitlist_failed": "Failed to move participations to waitlist",
    "edit_participation": "Edit participant",
    "add_team": "Add team",
    "no_eligible_series": "Participant is not eligible for any series based on gender, age or handicap.",
    "no_series_to_register": "No series available. Create series first.",
    "confirm_move_to_waitlist": "Are you sure you want to move the participant to waitlist?",
    "withdraw": "Withdraw participation",
    "confirm_withdraw_participation": "Are you sure you want to withdraw this participation?",
    "participation_withdrawn": "Participation withdrawn",
    "withdraw_failed": "Failed to withdraw participation",
    "remove_from_team": "Remove from team",
    "confirm_remove_from_team": "Are you sure you want to remove player {{name}} from the team?",
    "remove_from_team_failed": "Failed to remove player from team",
    "participant_removed": "Player removed from team",
    "edit_participation_info": "You can change the participant's series here.",
    "participation_updated": "Participation updated",
    "participation_created": "Participation added",
    "update_failed": "Update failed",
    "result_status_in_progress": "In Progress",
    "result_status_completed": "Completed",
    "result_status_abandoned": "Abandoned",
    "result_status_disqualified": "Disqualified",
    "result_status_withdrawn": "Withdrawn",
    "holes_played": "{{count}}/{{total}} holes",
    "mark_as_paid": "Mark as paid",
    "paid": "Paid",
    "select_fee": "Select fee",
    "marked_as_paid": "{{count}} participations marked as paid",
    "mark_as_paid_failed": "Failed to mark as paid",
    "failed_to_load_fees": "Failed to load fees",
    "no_fees_configured": "No fees configured",
    "multiple_series_selected": "Participants from multiple series selected",
    "select_price": "Select price",
    "fetch_from_profile": "Fetch from profile",
    "fetch_handicap_from_ebirdie": "Fetch handicap data",
    "handicap_factor_help": "Leave empty to use round's general handicap factor. This will override round settings for this player.",
    "handicap_factor_warning": "Handicap factor {{factor}}% in use",
    "no_user_linked": "No user profile linked to participant",
    "handicap_updated": "Handicap data updated",
    "no_handicap_in_profile": "No handicap in user profile",
    "failed_to_fetch_handicap": "Failed to fetch handicap",
    "fetch_all_handicaps": "Update handicap data",
    "no_linked_users": "No participants linked to user profiles",
    "handicaps_updated": "Handicaps updated",
    "some_handicaps_failed": "Failed to fetch {{count}} handicaps",
    "failed_to_fetch_handicaps": "Failed to fetch handicaps",
    "add_multiple_participations": "Add multiple",
    "add_players": "Add players",
    "all_players_need_series": "All players must have a series selected",
    "batch_save_success": "Saved",
    "multiple_series_match": "Multiple suitable series found for player",
    "participants_count": "Participants",
    "edit_team": "Edit team",
    "add_player_to_team": "Add player to team",
    "save_failed": "Save failed",
    "add_player": "Add",
    "add_multiple_players": "Add multiple",
    "back_to_competitions": "Back to competitions",
    "series_full_title": "Series is full",
    "series_full_message": "The series participant limit is full ({{currentCount}}/{{maxParticipants}}). Are you sure you want to add {{type}}?",
    "competition_full_title": "Competition is full",
    "competition_full_message": "The competition participant limit is full ({{currentCount}}/{{maxParticipants}}). Are you sure you want to add {{type}}?",
    "series_full_type_player": "the player",
    "series_full_type_players": "the players",
    "series_full_type_team": "the team",
    "add_as_confirmed_player": "Add player",
    "add_as_confirmed_players": "Add players",
    "add_as_confirmed_team": "Add team",
    "registered_by": "Registered by",
    "registration_time": "Registration time",
    "incompatible_series": "Incompatible series",
    "mark_as_paid_member_paid": "Paid",
    "select_members_to_mark_paid": "Select members to mark as paid",
    "waitlisted_divider": "On Waitlist",
    "paid_via_paytrail": "Paid via online payment",
    "filter_active": "Participants",
    "filter_cancelled": "Cancelled",
    "filter_unpaid": "Unpaid",
    "selected_tee_label": "Non-default tee",
    "selected_tee_help": "Leave empty to use the series default tee based on gender. A non-default tee affects the slope handicap calculation.",
    "abnormal_tee_indicator": "Non-default tee: {{teeName}}",
    "batch_send_email": "Send email",
    "send_email_modal_title": "Send email to participants",
    "send_email_subject_label": "Subject",
    "send_email_subject_placeholder": "E.g. Weather update for Saturday's round",
    "send_email_body_label": "Message",
    "send_email_body_placeholder": "Write your message...",
    "send_email_subject_required": "Subject is required",
    "send_email_body_required": "Message is required",
    "send_email_send": "Send",
    "send_email_cancel": "Cancel",
    "send_email_sending": "Sending...",
    "send_email_success": "Email sent",
    "send_email_failed": "Failed to send email",
    "sendEmailSwitch": {
      "label": "Send email",
      "batchLabel": "Send emails to all participants"
    },
    "confirmStatusChange": {
      "title": "Confirm status change",
      "body": "Confirming {{count}} participation(s).",
      "confirm": "Confirm",
      "cancel": "Cancel"
    },
    "ranking_eligible_on": "Affects ranking results",
    "ranking_eligible_off": "Does not affect ranking results",
    "batch_copy_emails": "Copy emails",
    "batch_export_emails_csv": "Download email list (CSV)",
    "copy_emails_success": "{{count}} email addresses copied to clipboard",
    "copy_emails_failed": "Failed to copy email addresses",
    "export_emails_csv_failed": "Failed to create CSV file",
    "refresh_handicaps_confirm": {
      "title": "Confirm Handicap Update",
      "update_result_playing_handicap": "Update playing handicap on scores",
      "ebirdie_submitted_warning": "The score has already been submitted to eBirdie and the playing handicap can no longer be updated.",
      "skipped_due_to_ebirdie": "Some playing handicap updates were skipped because the scores have already been submitted to eBirdie.",
      "batch_intro": "Update playing handicap on scores for the following players:",
      "select_all": "Select all",
      "ebirdie_row_label": "{{name}} (eBirdie)",
      "players_have_saved_results_one": "A player already has a saved score in this competition.",
      "players_have_saved_results_other": "Some players already have saved scores in this competition.",
      "batch_explanation": "These players already have a saved score in this competition."
    },
    "fee_modal": {
      "compulsory_alert": "This series includes a mandatory participation fee. You can mark it as paid now, or the player can pay it online when starting the round.",
      "voluntary_alert": "This series includes an optional participation fee. You can mark it as paid now, or the player can pay it online when starting the round.",
      "continue_without_payment": "Continue without payment"
    },
    "filter_button": "Filter",
    "filter_panel_title": "Filter participants",
    "filter_group_status": "Status",
    "filter_group_series": "Series",
    "filter_group_club": "Club",
    "filter_group_gender": "Gender",
    "filter_apply": "Show results ({{count}})",
    "cart_wish_on": "Wants a golf cart",
    "cart_wish_off": "Does not want a golf cart",
    "cart_wish_column": "Golf cart"
  },
  "upcoming_competitions": "Upcoming Competitions",
  "competition_round": "Competition Round",
  "upload_image": "Upload image",
  "upload_invitation": "Upload invitation",
  "change_image": "Change image",
  "change_invitation": "Change invitation",
  "remove_image": "Remove image",
  "remove_invitation": "Remove invitation",
  "image_uploaded": "Image uploaded",
  "invitation_uploaded": "Invitation uploaded",
  "image_removed": "Image removed",
  "invitation_removed": "Invitation removed",
  "failed_to_upload_image": "Failed to upload image",
  "failed_to_upload_invitation": "Failed to upload invitation",
  "failed_to_remove_image": "Failed to remove image",
  "failed_to_remove_invitation": "Failed to remove invitation",
  "invalid_file_type": "Invalid file type",
  "invalid_invitation_type": "Invalid file type. Allowed: PDF, JPEG, PNG, WebP",
  "file_too_large": "File is too large",
  "uploading": "Uploading...",
  "removing": "Removing...",
  "view_button": "View",
  "view_invitation": "View invitation",
  "invitation_formats": "PDF, JPEG, PNG, WebP",
  "weekly_competitions_available": "Weekly Competitions",
  "select_competitions_to_participate": "Select the weekly competition you want to participate in with this round",
  "submitted_scores": "Submitted Scores",
  "counting_scores": "Counting Scores",
  "eligible_series": "Eligible Series",
  "failed_to_load_weekly_competitions": "Failed to load weekly competitions",
  "tee_selection_disabled_by_competition": "Tee set is determined by competition series settings",
  "fees": {
    "title": "Entry Fee",
    "compulsory_description": "Entry fee is mandatory. The fee is paid during registration.",
    "voluntary_description": "Entry fee is voluntary. You can pay during registration or later."
  },
  "playTypes": {
    "SINGLE": "Individual",
    "STROKE_PLAY": "Stroke Play",
    "STABLEFORD": "Stableford",
    "PAR_BOGEY": "Par/Bogey",
    "MATCH_PLAY": "Match Play",
    "GREENSOME": "Greensome",
    "FOURSOME": "Foursome",
    "SCRAMBLE": "Scramble",
    "BEST_BALL": "Best Ball",
    "FOUR_BALL": "Four Ball (2 players)",
    "IRISH_RUMBLE": "Irish Rumble",
    "MATCH": "Team Match (Ryder Cup style)",
    "BRACKET": "Bracket (Match Play)",
    "LEAGUE": "League"
  },
  "filters": {
    "all_clubs": "All Clubs",
    "no_tenant": "No club"
  },
  "competition_info": {
    "basic_info_title": "Basic Information",
    "registration_settings_title": "Registration Settings",
    "media_title": "Visual Identity and Attachments"
  },
  "series_fees": {
    "payment_settings_title": "Pricing and Payment",
    "title": "Prices",
    "name": "Description",
    "amount": "Amount",
    "add_fee": "+ Add Price",
    "saved": "Fees saved",
    "no_fees": "No fees",
    "name_placeholder": "E.g. Entry fee",
    "created": "Fee added",
    "updated": "Fee updated",
    "deleted": "Fee deleted",
    "load_failed": "Failed to load fees",
    "save_failed": "Failed to save fee",
    "delete_failed": "Failed to delete fee",
    "invalid_amount": "Invalid amount",
    "delete_title": "Delete Fee",
    "confirm_delete": "Are you sure you want to delete this fee?",
    "no_fees_info": "No fees have been set for this series.",
    "add_fee_link": "Add fee."
  },
  "flights": {
    "title": "Flights",
    "delete_flights": "Delete Flights",
    "confirm_delete_flights": "Are you sure you want to delete the selected flights? This action cannot be undone.",
    "deleted_successfully": "Flights deleted successfully",
    "delete_failed": "Failed to delete flights",
    "edit_entry_title": "Edit Flight",
    "select_participant": "Select participant",
    "no_flights": "No flights",
    "add_participant": "Add",
    "flight_lottery": "Lottery",
    "run_lottery": "Run Draw",
    "lottery_confirm_title": "Run Flight Draw",
    "lottery_confirm_body": "This will remove all current flights and create new ones with a random distribution of participants. Do you want to continue?",
    "lottery_success": "Draw completed successfully. Created {{count}} flights.",
    "lottery_failed": "Failed to run the draw",
    "lottery_mode": "Draw Mode",
    "lottery_mode_random": "Random Draw",
    "lottery_mode_registration_order": "Registration Order",
    "lottery_mode_random_description": "Participants are drawn in a random order",
    "lottery_mode_registration_order_description": "Participants are ordered by registration order",
    "lottery_mode_results_reversed": "Reversed by Results",
    "lottery_mode_results_reversed_description": "Players are ordered by previous round results — worst scores first",
    "lottery_by_series": "Draw by Series",
    "lottery_by_series_description": "Each series is drawn separately into its own flights",
    "lottery_by_series_disabled_single": "The competition has only one series",
    "preserve_existing_order": "Preserve Existing Order",
    "preserve_existing_order_description": "New flights are added after existing ones",
    "respect_start_time_preferences": "Respect Tee Time Preferences",
    "respect_start_time_preferences_description": "Players preferring early tee times are placed first, late tee times last",
    "respect_start_time_preferences_note": "Tee time preference is not active in registration order mode",
    "reorder_success": "Flight order updated",
    "reorder_failed": "Failed to update flight order",
    "entry_moved": "Participant moved",
    "move_failed": "Move failed",
    "edit_flight": "Edit Flight",
    "no_entries": "No players in flight",
    "empty_slot": "Empty slot",
    "unknown_participant": "Unknown participant",
    "entry_removed": "Player removed from flight",
    "remove_entry_failed": "Failed to remove player",
    "flight_updated": "Flight updated",
    "update_failed": "Failed to update flight",
    "unsaved_changes_warning": "You have unsaved changes. Do you want to continue?",
    "pdf_columns": "Select columns",
    "export_pdf": "Download PDF",
    "publish_flights": "Publish Flights",
    "flights_published": "Flights published",
    "flights_unpublished": "Flights hidden",
    "publish_toggle_failed": "Failed to change publish status",
    "flights_not_published": "Flights have not been published.",
    "publish_flights_link": "Publish.",
    "cut_was_needed_alert": "The cut for the previous round has not been executed:",
    "check_cut_status": "Go to execute cut for series {{seriesName}}",
    "no_participants": "No players",
    "cannot_delete_has_results": "Flights with saved scores cannot be deleted. Please remove the scores first.",
    "publish_modal_title": "Publish flights",
    "publish_modal_body": "The flights are ready to be published.",
    "publish_modal_notify_checkbox": "Send tee time notification to all confirmed participants",
    "publish_modal_publish_button": "Publish",
    "send_start_times_to_selected": "Send tee times to selected",
    "send_start_times_success": "Tee time notifications sent",
    "send_start_times_failed": "Failed to send tee time notifications",
    "start_time_sent": "Tee time notification sent",
    "start_time_not_sent": "Tee time notification not sent",
    "send_start_time": "Send tee time by email",
    "resend_start_time": "Tee time notification sent — resend",
    "resend_start_time_title": "Send tee time notification",
    "resend_start_time_body": "Send tee time notification to player <strong>{{name}}</strong> ({{email}})?",
    "start_time_no_email_address": "Player has no email address — notification cannot be sent",
    "add_flights_button": "Add flights",
    "create_flights_modal_title": "Create empty flights",
    "create_flights_count_label": "Number of flights",
    "create_flights_count_validation": "Enter a positive integer",
    "create_flights_submit_button": "Create",
    "flights_created": "Created {{count}} flights",
    "create_failed": "Failed to create flights",
    "cannot_remove_entry_has_results": "A player with saved scores cannot be moved or removed from the flight. Please remove the scores first.",
    "publish_modal_audience_label": "Tee time visibility",
    "audience_modal_title": "Change tee time visibility",
    "audience_updated": "Visibility updated"
  },
  "results": {
    "scorecards": "Scorecards",
    "no_results": "No results",
    "edit_result_title": "Edit Result",
    "edit_placeholder": "Result editing feature coming soon...",
    "creating_result": "Creating result...",
    "saving_result": "Saving result...",
    "saving_all": "Saving all...",
    "deleting_result": "Deleting result...",
    "delete_result": "Delete Result",
    "delete_confirm": "Are you sure you want to delete this result?",
    "result_saved": "Result saved",
    "all_results_saved": "All results saved",
    "some_saves_failed": "Failed to save {{count}} result(s)",
    "result_deleted": "Result deleted",
    "save_failed": "Save failed",
    "delete_failed": "Delete failed",
    "save_current": "Save",
    "save_all_close": "Save All and Close",
    "unsaved_changes_warning": "You have unsaved changes. Do you want to continue?",
    "edit_flight": "Edit flight results",
    "edit_team_result": "Edit team result",
    "edit_player_result": "Edit player result",
    "disqualified": "Disqualified",
    "withdrawn": "Withdrawn",
    "disqualification_reason": "Disqualification reason",
    "set_to_par_superuser": "Set to par (superuser)",
    "editing_scorecard": "Editing scorecard",
    "saved_successfully": "Saved successfully",
    "does_not_affect_handicap": "Does not affect handicap",
    "cut_needed_alert": "The cut for this round has not been executed:",
    "execute_cut": "Go to execute cut for series {{seriesName}}",
    "hints": {
      "does_not_affect_handicap": "When enabled, this scorecard's score will not be submitted to eBirdie"
    },
    "scorecard_signed": "Scorecard signed",
    "publish_results": "Publish results",
    "results_published": "Results published",
    "results_unpublished": "Results hidden",
    "publish_toggle_failed": "Failed to change publish status",
    "results_not_published": "Results have not been published",
    "publish_modal_title": "Publish results",
    "publish_modal_body": "Publishing makes the results visible to participants and in the public competition calendar.",
    "publish_modal_notify_checkbox": "Send results notification to all players in the round",
    "publish_modal_publish_button": "Publish",
    "live": "Live",
    "refresh": "Refresh",
    "publish_modal_audience_label": "Results visibility",
    "audience_modal_title": "Change results visibility",
    "audience_updated": "Visibility updated",
    "publish_modal_body_society": "Publishing will make the results visible to members."
  },
  "scoring": {
    "select_series": "Select Series",
    "no_series": "No series",
    "no_rounds": "No rounds",
    "no_results": "No results available",
    "error_loading_rankings": "Failed to load results",
    "resultType": "Result type",
    "resultTypes": {
      "strokeScratch": "Stroke Play Scratch",
      "strokeHcp": "Stroke Play HCP",
      "stablefordScratch": "Stableford Scratch",
      "stablefordHcp": "Stableford HCP",
      "maxScoreScratch": "Max Score Scratch",
      "maxScoreHcp": "Max Score HCP",
      "system36": "System 36"
    },
    "round": "Round",
    "round_abbrev": "R",
    "cumulative": "Cumulative",
    "hole_details": "Hole-by-hole results",
    "rank": "Rank",
    "team": "Team",
    "player": "Player",
    "players": "Players",
    "score": "Score",
    "total": "Total",
    "front9": "Out",
    "back9": "In",
    "relative_to_par": "Par +/-",
    "cut_line": "Cut Line",
    "apply_cut": "Apply CUT",
    "remove_cut": "Remove CUT",
    "cut_applied_success": "CUT applied: {{count}} player(s) eliminated",
    "cut_removed_success": "CUT removed: {{count}} player(s) reinstated",
    "cut_apply_error": "Failed to apply CUT",
    "cut_remove_error": "Failed to remove CUT",
    "team_results": "Team Results",
    "individual_results": "Individual Results",
    "cumulative_results": "Cumulative Results",
    "no_valid_strokeplay_result": "No strokeplay result",
    "liveScoringLauncher": {
      "title": "Live Scoring",
      "playersPerPage": "Players per page",
      "pageRotation": "Page rotation",
      "seconds": "seconds",
      "off": "Off",
      "showHoleDetails": "Hole-by-hole results",
      "previewUrl": "Preview URL",
      "openLiveView": "Open",
      "cancel": "Cancel",
      "matchesPerPage": "Matches per page",
      "rounds": "Rounds to display",
      "roundsHint": "Select the rounds you want to display. Leave empty to show all.",
      "seriesToShow": "Series and score types to display",
      "teamsPerPage": "Teams per page",
      "autoFit": "Automatic (fit to screen)"
    },
    "par": "Par",
    "cut_available_alert": "Cut must be executed:",
    "go_to_cut": "Go to execute cut for series {{seriesName}}",
    "cut_warning_title": "Warning: different score type",
    "cut_warning_confirm": "Execute cut",
    "cut_result_type_mismatch_warning": "Warning: current score type does not match the series' primary score type. Are you sure you want to execute the cut based on these scores?\n\nCurrent score type: {{currentType}}\nSeries primary score type: {{defaultType}}\nSeries: {{seriesName}}",
    "flight_scoring": {
      "tabs": {
        "results": "Results",
        "leaderboard": "Leaderboard"
      },
      "hole": "Hole",
      "last_modified_by": "Last modified by",
      "finish_button": "Finalize scores",
      "error_loading": "Failed to load scores",
      "leaderboard_placeholder": "Leaderboard view coming soon",
      "exit_confirm_header": "Do you want to exit?",
      "exit_confirm_body": "You can continue entering scores later. Entered scores will not be lost.",
      "exit_confirm_yes": "Yes",
      "exit_confirm_no": "No",
      "unsaved_changes_header": "Unsaved changes",
      "unsaved_changes_body": "You have unsaved scores for this hole. Do you want to continue without saving or return to save?",
      "unsaved_changes_save": "Return to save",
      "unsaved_changes_continue": "Continue without saving",
      "saving": "Saving...",
      "not_started": "Not started",
      "save_scores": "Save scores",
      "review_scorecard": "Review and sign scorecards",
      "overwrite_confirm_title": "You are changing a hole score",
      "overwrite_confirm_notification_warning": "Other players will be notified of the change!",
      "overwrite_confirm_old_score": "Old score",
      "overwrite_confirm_new_score": "New score",
      "overwrite_confirm_removed": "removed",
      "notification_title": "Scores changed",
      "notification_changed_score": "{{changedBy}} changed player {{playerName}}'s score on hole {{hole}}",
      "notification_old_new": "Old: {{old}} → New: {{new}}",
      "notification_score_removed": "removed",
      "notification_ok": "OK",
      "notification_changed_score_team": "{{changedBy}} changed team {{playerName}}'s score on hole {{hole}}",
      "status_short_dq": "DQ",
      "status_short_wd": "WD",
      "overwrite_confirm_player_label": "Player",
      "overwrite_confirm_score_label": "Score",
      "notification_change_label": "Change",
      "notification_edited_by": "Edited by {{changedBy}}",
      "notification_changed_result": "changed the score"
    },
    "playing_handicap_tooltip": "Playing handicap: {{value}}",
    "ties_broken_by": "Tiebreaker",
    "using_default_draw_decision": "Using default: shared positions, mathematical order",
    "no_explicit_config": "Not defined for this score type",
    "primary_short": "Primary",
    "secondary_short": "Secondary",
    "system36Handicap": "HCP"
  },
  "participation": {
    "searchPlayer": "Search player",
    "allClubs": "All clubs",
    "nameOrMemberNumber": "Name or member number",
    "search": "Search",
    "noResults": "No results",
    "already_registered": "Registered",
    "localPlayers": "Other Impact users",
    "localSearchPlaceholder": "Search by name or email",
    "allPlayers": "All players",
    "societyMembers": "Society members",
    "selectSocietyMember": "Select or search for a member"
  },
  "participations": {
    "pdf_columns": "Select columns",
    "export_pdf": "Download PDF"
  },
  "pdf": {
    "filename_start_list": "start-list",
    "filename_participants": "participants",
    "filename_results": "results",
    "filename_team_results": "team",
    "filename_individual_results": "individual"
  },
  "timeSchedule": {
    "templates": "Pace of Play Templates",
    "addTemplate": "Add Template",
    "createTemplate": "Create Pace of Play Template",
    "editTemplate": "Edit Pace of Play Template",
    "templateName": "Template Name",
    "templateNamePlaceholder": "E.g. Normal round - weekend",
    "expectedTimePerHole": "Time per hole (minutes)",
    "description": "Description",
    "descriptionPlaceholder": "Template description...",
    "selectScorecard": "Select Scorecard",
    "selectScorecardPlaceholder": "Select scorecard...",
    "selectCourse": "Select Course",
    "selectCoursePlaceholder": "Select course...",
    "holeTime": "Hole {{number}}",
    "hole": "Hole",
    "totalTime": "Target time 18 holes",
    "totalExpectedTime": "Total target time",
    "minutes": "min",
    "applyToAll": "Apply to all",
    "applyToAllHint": "Set the same time for all holes",
    "noTemplates": "No templates",
    "noTemplatesMessage": "Create your first template to define the expected playing time per hole.",
    "createFirst": "Create first template",
    "loadingTemplates": "Loading templates...",
    "failedToLoad": "Failed to load templates",
    "templateCreated": "Template created successfully",
    "templateUpdated": "Template updated successfully",
    "templateDeleted": "Template deleted successfully",
    "createFailed": "Failed to create template",
    "updateFailed": "Failed to update template",
    "deleteFailed": "Failed to delete template",
    "confirmDelete": "Are you sure you want to delete the template \"{{name}}\"?",
    "deleteTemplate": "Delete Template",
    "deleteSuccess": "Template deleted successfully",
    "updateSuccess": "Template updated successfully",
    "createSuccess": "Template created successfully",
    "saveTemplate": "Save Template",
    "cancel": "Cancel",
    "holes": "{{count}} holes",
    "holeCount": "{{count}} holes",
    "holesHeader": "Holes",
    "course": "Course",
    "manageTemplates": "Manage Pace of Play Templates",
    "manageDescription": "Create and manage pace of play templates that can be used to track round pace.",
    "frontNine": "Holes 1-9",
    "backNine": "Holes 10-18",
    "frontNineTime": "Front nine time",
    "backNineTime": "Back nine time",
    "searchTemplates": "Search templates",
    "duration": "Duration",
    "out": "Out",
    "in": "In",
    "errors": {
      "nameRequired": "Template name is required",
      "scorecardRequired": "Course is required",
      "invalidTime": "All hole times must be set to at least 1 minute",
      "saveFailed": "Failed to save template",
      "loadFailed": "Failed to load templates",
      "deleteFailed": "Failed to delete template"
    }
  },
  "timeTracking": {
    "title": "Pace of Play Tracking",
    "enableTracking": "Enable pace of play tracking",
    "selectTemplate": "Select pace of play template",
    "selectTemplatePlaceholder": "Select template...",
    "noTemplate": "No template selected",
    "warningThreshold": "Warning threshold (minutes)",
    "warningThresholdHelp": "Show a warning when a group is this many minutes behind schedule",
    "dangerThreshold": "Danger threshold (minutes)",
    "dangerThresholdHelp": "Show a danger alert when a group is this many minutes behind schedule",
    "overrideEnabled": "Override tracking",
    "overrideReason": "Override reason",
    "overrideReasonPlaceholder": "Explain why pace tracking is overridden, e.g. weather conditions...",
    "noTrackingConfigured": "Pace of play tracking has not been configured for this competition.",
    "configureTracking": "Configure Tracking",
    "trackingEnabled": "Tracking enabled",
    "trackingDisabled": "Tracking disabled",
    "saveSuccess": "Pace of play tracking saved",
    "deleteSuccess": "Pace of play tracking removed",
    "saveFailed": "Failed to save pace of play tracking",
    "deleteFailed": "Failed to remove pace of play tracking",
    "confirmDelete": "Are you sure you want to remove pace of play tracking from this competition?",
    "removeTracking": "Remove Tracking",
    "templateInfo": "Template: {{name}}",
    "expectedTime": "Expected playing time: {{time}}",
    "thresholds": "Thresholds",
    "settings": "Settings"
  },
  "paceOfPlay": {
    "warningMessage": "Pace of play warning",
    "dangerWarning": "Pace of play critical!",
    "behindSchedule": "{{minutes}} minutes behind schedule",
    "aheadSchedule": "{{minutes}} minutes ahead of schedule",
    "onPace": "On pace",
    "status": {
      "onPace": "On pace",
      "catchingUp": "Catching up",
      "warning": "Warning - slow pace",
      "danger": "Danger - very slow pace"
    },
    "gap": {
      "rootCause": "Causing delay",
      "gapToGroupAhead": "Gap to group ahead",
      "expectedGap": "Expected gap",
      "actualGap": "Actual gap",
      "unavailable": "Tracking unavailable",
      "noGroupAhead": "First flight",
      "minutes": "{{minutes}} min"
    },
    "tracking": {
      "enabled": "Tracking enabled",
      "disabled": "Tracking disabled",
      "holesCompleted": "{{holes}} holes played"
    }
  },
  "payment": {
    "success_title": "Payment Successful",
    "success_message": "Your registration has been confirmed.",
    "cancelled_title": "Payment Cancelled",
    "cancelled_message": "Payment was not completed. You can try again.",
    "back_to_competitions": "Back to competitions",
    "fee_label": "Entry fee",
    "pay_now": "Pay now",
    "complete_payment": "Complete payment",
    "paid": "Paid",
    "failed_required_title": "Payment Failed",
    "failed_required_message": "The payment was not completed, so your registration was not recorded. You can try again.",
    "failed_voluntary_title": "Payment Failed",
    "failed_voluntary_message": "Your registration has been recorded, but the payment was not completed. You can pay later or try again now.",
    "retry_payment": "Retry Payment",
    "retry_registration": "Retry Registration",
    "back_to_round_start": "Back to round start",
    "pay_later": "Pay later"
  },
  "weekly": {
    "competition": "Weekly Competition",
    "score_details_for": "Scores for player",
    "no_competitions": "No weekly competitions available",
    "loading_competitions": "Loading weekly competitions...",
    "failed_to_load_competitions": "Failed to load weekly competitions",
    "register_for_competition": "Register for weekly competition",
    "registered_competitions": "Weekly competition registrations",
    "view_results": "View results",
    "position": "#",
    "player": "Player",
    "rounds_played": "Rounds",
    "total_score": "Total Score",
    "best_scores": "Best",
    "rounds_counted": "Counted",
    "all_scores": "Scores",
    "actions": "Actions",
    "view_details": "View scores",
    "add_score": "Add score",
    "date": "Date",
    "course": "Course",
    "tee_set": "Tee",
    "strokes": "Strokes",
    "stableford_points": "Points",
    "delete": "Delete score",
    "delete_score_title": "Delete Score",
    "no_scores_submitted": "No scores submitted yet",
    "confirm_delete_score": "Are you sure you want to delete this score?",
    "score_deleted": "Score deleted",
    "deleting": "Deleting...",
    "view_scorecard": "View scorecard",
    "admin_score_entry": "Score Entry",
    "not_weekly_competition": "This is not a weekly competition",
    "no_results": "No results",
    "insufficient_rounds": "Insufficient rounds",
    "status": "Status",
    "ebirdie_sent_tooltip": "Sent to eBirdie {{date}}, id: {{id}}",
    "series": "Series",
    "payment_required_pill": "Payment required",
    "payment_voluntary_pill": "Payment optional"
  },
  "tvLeaderboard": {
    "page": "Page {{current}} / {{total}}",
    "updated": "Updated: {{time}}",
    "rank": "RANK",
    "player": "PLAYER",
    "leaderScore": "LEADER SCORE",
    "total": "TOT",
    "today": "TODAY",
    "thru": "THRU",
    "round": "R",
    "finished": "F",
    "withdrawn": "WD",
    "disqualified": "DQ",
    "loading": "Loading leaderboard...",
    "error_title": "Leaderboard could not be loaded",
    "no_data": "No data available",
    "missing_params": "Required URL parameters: seriesId, roundIds",
    "hole": "#",
    "out": "Out",
    "in": "In",
    "strokes": "Tot",
    "par": "PAR",
    "live": "LIVE",
    "flights_not_published": "Flights have not been published",
    "enterFullscreen": "Enter fullscreen mode",
    "exitFullscreen": "Exit fullscreen mode"
  },
  "handicap_recommendations": {
    "title": "Golf Federation Recommendations",
    "disclaimer": "These are the Finnish Golf Federation's recommendations for playing handicaps. You can use them as-is, modify them, or set your own values.",
    "multiple_found": "Multiple recommendations found. Select the most appropriate option.",
    "button_label": "Recommendations",
    "button_title": "Show Golf Federation recommendations",
    "apply": "Apply",
    "handicap_factor": "Handicap factor",
    "team_percentages": "Team %",
    "men_max": "Men max",
    "women_max": "Women max"
  },
  "player_view": {
    "tabs": {
      "info": "Info",
      "participants": "Participants",
      "flights": "Flights",
      "results": "Results",
      "bracket": "Bracket",
      "ryder_cup": "Team Match"
    },
    "status": {
      "registered": "Registered",
      "waitlisted": "Waitlisted"
    },
    "register": "Register for competition",
    "join_waitlist": "Join waitlist",
    "leave_waitlist": "Leave waitlist",
    "cancel_registration": "Cancel registration",
    "cancel_confirm_header": "Cancel Registration",
    "cancel_confirm_body": "Are you sure you want to cancel your registration?",
    "leave_waitlist_confirm_header": "Leave Waitlist",
    "leave_waitlist_confirm_body": "Are you sure you want to leave the waitlist?",
    "waitlist_cancelled_success": "You have left the waitlist",
    "registration_cancelled_success": "Your registration has been cancelled",
    "open_live_scoring": "Open Live Scoring",
    "info": {
      "pay_competition_fee": "Pay competition fee",
      "competition_invitation": "Competition invitation",
      "date": "Date",
      "registration": "Registration",
      "registration_closed": "Registration closed",
      "invite_only": "Invitation only",
      "participant_count": "Participants",
      "competition_info": "Competition info",
      "prices": "Prices",
      "no_eligible_series": "You cannot register for this competition because no eligible series was found for you.",
      "restriction_not_met": "You do not meet the registration requirements.",
      "restriction": {
        "EBIRDIE_MEMBERS": "Registration is restricted to Golf Federation members.",
        "HOME_CLUB_MEMBERS": "Registration is restricted to home club members.",
        "SELECTED_CLUBS": "Registration is restricted to members of selected clubs.",
        "SOCIETY_MEMBERS": "Registration is restricted to society members."
      },
      "your_match": "Your match",
      "match_opponent": "Opponent",
      "match_round": "Round",
      "match_status": "Status",
      "match_tee_time": "Tee time",
      "match_hole": "Hole",
      "no_eligible_series_weekly": "You cannot submit a score because no suitable series was found for you."
    },
    "participants": {
      "header": "Participants",
      "club": "Club",
      "hcp": "HCP",
      "no_participants": "No participants"
    },
    "flights": {
      "not_published": "Flights have not been published",
      "tee": "Tee",
      "time": "Time",
      "name": "Name",
      "club": "Club",
      "slope": "Slope",
      "round": "Round",
      "no_flights": "No flights",
      "enter_scores": "Enter scores",
      "startHole": "Hole",
      "player": "Player",
      "team": "Team"
    },
    "results": {
      "par": "PAR",
      "score": "Score",
      "net": "NET",
      "finished": "F",
      "no_results": "No results",
      "hole": "Hole",
      "out": "OUT",
      "in": "IN",
      "series": "Series",
      "round": "Round",
      "my_flight": "My flight",
      "all_players": "All players",
      "points": "Pts",
      "played_abbrev": "PLD",
      "total_abbrev": "TOT"
    },
    "registration": {
      "title": "Competition Registration",
      "select_series": "Select series",
      "start_time_preference": "Tee time preference",
      "start_time_early": "Early",
      "start_time_late": "Late",
      "notes": "Additional information",
      "notes_guideline": "Max. 180 characters",
      "notes_placeholder": "Additional information (max. 180 characters)",
      "back": "Back",
      "next": "Next",
      "register": "Register",
      "continue": "Continue",
      "terms_title": "Registration Terms",
      "terms_prompt": "Do you accept the terms",
      "terms_reject": "No, reject",
      "terms_accept": "Yes, I accept",
      "confirmed_title": "Registered",
      "waitlisted_title": "Waitlisted",
      "withdrawn_title": "Registration Cancelled",
      "confirmed_message": "Registration completed successfully!",
      "waitlisted_message": "You have been added to the waitlist!",
      "withdrawn_message": "Your registration has been cancelled successfully.",
      "back_to_competition": "Back to competition",
      "spots_remaining": "{{count}} spots remaining",
      "series_full": "Series full",
      "waitlist_available": "Waitlist available",
      "error": "Registration failed",
      "birthdate_required": "The series has age restrictions. Your date of birth has not been set.",
      "set_birthdate": "Set date of birth",
      "save_birthdate": "Save",
      "payment_title": "Payment",
      "paid_title": "Paid",
      "payment_fee_item": "1 x {{feeName}}",
      "payment_total_label": "Amount to charge",
      "payment_secure": "Secure payment",
      "payment_paytrail": "Paytrail is a domestic",
      "payment_pay_later": "Pay later",
      "payment_go_to_pay": "Proceed to payment",
      "payment_error": "Failed to initiate payment. Please try again later.",
      "payment_fee_item_team": "{{count}} x {{feeName}}",
      "payment_per_player": "/ player",
      "payment_select_players": "Select who you are paying for",
      "payment_partial_warning": "Players left unpaid can pay later",
      "team_name": "Team name",
      "team_name_placeholder": "Enter team name",
      "players_count": "Players {{count}}/{{max}}",
      "search_placeholder": "Name or member number",
      "search_club": "Club",
      "search_button": "Search",
      "search_results": "Search results",
      "search_add": "Add",
      "search_close": "Close",
      "search_no_results": "No search results",
      "register_partial_team": "Register partial team",
      "player_already_registered": "Player is already registered",
      "player_ineligible_gender": "Player does not meet the series gender requirement",
      "player_ineligible_age": "Player does not meet the series age requirement",
      "player_ineligible_handicap": "Player's handicap is not within the series allowed range",
      "player_already_added": "Player has already been added to the team",
      "payment_select_fee": "Select price",
      "payment_select_fee_per_player": "Select fee per player",
      "terms_body": "I accept the registration terms, the binding nature of the registration and the associated competition fee charge.",
      "payment_member_already_paid": "Paid",
      "payment_all_members_paid": "All team members have paid",
      "event_title": "Event Registration",
      "terms_body_event": "I accept the registration terms, the binding nature of the registration, and the associated event fee charge.",
      "birthdate_card_title": "Add date of birth",
      "birthdate_card_subtitle": "Age restrictions are in use for series",
      "birthdate_card_action": "Set",
      "birthdate_modal_title": "Set date of birth",
      "birthdate_modal_field_label": "Date of birth",
      "birthdate_modal_placeholder": "DD.MM.YYYY",
      "cart_wish_label": "I want a golf cart",
      "cart_wish_checkbox_title": "Golf cart",
      "cart_wish_default_info": "Confirm golf cart availability with the caddiemaster"
    },
    "open_scoring": "Open scoring",
    "register_event": "Register for Event",
    "open_scoring_weekly": "Enter score",
    "bracket": {
      "not_published": "Bracket has not been published"
    }
  },
  "waitlist": {
    "modal": {
      "title": "Competition is Full",
      "body": "{{competitionName}} is full. Would you like to join the waitlist?",
      "accept": "Yes, join waitlist",
      "decline": "Cancel"
    },
    "declined_message": "Registration cancelled. Competition is full and waitlist was not accepted."
  },
  "not_public_banner": {
    "text": "The event is not public. Players will not see this event in the competition calendar.",
    "publish_link": "Publish.",
    "publish_success": "Event published",
    "publish_failed": "Publishing failed",
    "textSociety": "The event has not been published yet. Members will not see this event before it is published."
  },
  "ebirdie": {
    "submit": "Submit to eBirdie",
    "cancel_submission": "Cancel eBirdie submission",
    "submit_success": "{{count}} scores submitted to eBirdie",
    "submit_skipped": "{{count}} scores do not meet submission requirements",
    "submit_failed": "{{count}} scores failed to submit",
    "no_results": "No scores to submit",
    "submit_error": "eBirdie submission failed",
    "status_submitted": "Submitted to eBirdie",
    "status_queued": "Pending submission to eBirdie",
    "status_failed": "eBirdie submission failed",
    "cancel_confirm_title": "Cancel eBirdie Submission",
    "cancel_confirm_body": "Are you sure you want to cancel the eBirdie submission for all scores? eBirdie may reject cancellations older than 7 days.",
    "cancel_confirm_button": "Cancel Submission",
    "cancel_success": "eBirdie submission cancelled for {{count}} scores",
    "cancel_skipped": "{{count}} scores skipped",
    "cancel_failed": "{{count}} scores failed to cancel",
    "cancel_error": "Cancelling eBirdie submission failed",
    "submit_selected": "Export selected ({{count}}) to eBirdie",
    "cancel_selected": "Cancel selected ({{count}})"
  },
  "public_calendar": {
    "page_title": "Competition calendar",
    "tenant_not_found": "Club not found",
    "meta_description": "{{club}} competition calendar – all upcoming golf competitions",
    "login": "Log in",
    "empty": "No public competitions"
  },
  "scorecard_review": {
    "title": "Scorecard review",
    "back_to_scoring": "Back to score entry",
    "close": "Close and return to main page",
    "previous_player": "Previous player",
    "next_player": "Next player",
    "return_to_scoring": "Return to score entry",
    "confirm_and_sign": "Confirm and sign",
    "conflict_warning": "This player has conflicts that have been resolved automatically",
    "all_holes_required": "Scores for all holes must be entered before signing",
    "conflicts_must_be_resolved": "All conflicts must be resolved before signing",
    "confirm_title": "Confirm and sign scorecard",
    "confirm_message": "Are you sure you want to sign the scorecard?\n\nOnce signed, scores can no longer be edited from the player view. Changes will require administrator action.",
    "cancel": "Cancel",
    "sign": "Sign",
    "signing_error": "Error signing scores. Please try again.",
    "no_results": "No scores found",
    "signing_processing": "Signing...",
    "signing_done": "Signed.",
    "sign_player": "Sign scorecard",
    "unsign_player": "Revoke signature",
    "confirm_sign_player": "Are you sure you want to sign player {{playerName}}'s scorecard?",
    "signed_badge": "Signed",
    "unsign_error": "Error revoking signature. Please try again.",
    "player_holes_required": "Scores for all holes must be entered before signing",
    "player_conflicts": "Player has unresolved conflicts",
    "all_signed_title": "Scorecards signed",
    "all_signed_description": "If you need changes to the scorecards, please contact the competition organizers",
    "all_signed_close": "Close"
  },
  "eligible_series_singular": "Series",
  "series_options_count": "{{count}} options",
  "choose_series": "Select series",
  "special_competitions": {
    "section": {
      "title": "Special competitions",
      "add": "Add special competition",
      "empty": "This round has no special competitions.",
      "save_first_hint": "Save the round before adding special competitions.",
      "history": "Results",
      "load_error": "Failed to load special competitions.",
      "delete_error": "Failed to delete special competition.",
      "confirm_delete_header": "Delete special competition",
      "confirm_delete_body": "Are you sure you want to delete this special competition? All related entries will also be deleted."
    },
    "form": {
      "title_add": "Add special competition",
      "title_edit": "Edit special competition",
      "name": "Name",
      "hole_number": "Hole number",
      "unit": "Unit",
      "unit_placeholder": "e.g. m, cm, yd",
      "direction": "Winner",
      "direction_none": "Latest entry",
      "direction_max_wins": "Highest value",
      "direction_min_wins": "Lowest value"
    },
    "direction": {
      "MAX_WINS": "Highest value",
      "MIN_WINS": "Lowest value"
    },
    "history": {
      "title": "Special competition results: {{name}}",
      "title_generic": "Special competition results",
      "player": "Player",
      "value": "Score",
      "submitted_by": "Recorded by",
      "submitted_at": "Time",
      "empty": "No entries.",
      "load_error": "Failed to load results.",
      "delete_error": "Failed to delete entry.",
      "confirm_delete_header": "Delete entry",
      "confirm_delete_body": "Are you sure you want to delete this entry? The previous entry will become the new leader.",
      "add_record_submit": "Save result",
      "add_record_participant_label": "Player",
      "add_record_value_label": "Score",
      "add_record_load_error": "Failed to load players",
      "add_record_submit_error_default": "Failed to save score",
      "add_record_participant_placeholder": "Search for a player...",
      "add_record_no_options": "No players"
    },
    "results": {
      "title": "Special competitions",
      "no_leader": "No results"
    },
    "pdf": {
      "column_hole": "Hole",
      "column_name": "Competition",
      "column_leader": "Leader",
      "column_value": "Score",
      "no_leader_yet": "-"
    },
    "panel": {
      "card": {
        "no_leader": "No results",
        "set_button": "Set",
        "change_button": "Change"
      },
      "modal": {
        "eyebrow": "Hole {{hole}} - Side competition",
        "help_with_unit": "Select a player and enter the measurement.",
        "help_no_value": "Select a player.",
        "value_label": "Measurement ({{unit}})",
        "submit": "Save",
        "cancel": "Cancel",
        "cancel_record": "Remove entry",
        "cancel_confirm": {
          "title": "Remove entry?",
          "confirm": "Remove entry",
          "dismiss": "Close"
        }
      }
    }
  },
  "publicRankings": {
    "page_title": "Ranking",
    "empty_state": "No published ranking series for this year",
    "year_filter_label": "Year",
    "back_to_list": "Back"
  },
  "competitions": {
    "public_view": {
      "linked_ranking_series_label": "Ranking series"
    }
  },
  "competition_form": {
    "categories_label": "Categories",
    "categories_placeholder": "Select categories..."
  },
  "categories": {
    "title": "Categories",
    "create": "Add category",
    "edit_category": "Edit category",
    "name_label": "Category name",
    "slug_label": "URL slug",
    "url_label": "Page URL",
    "url_help_immutable": "The URL is generated automatically from the name and cannot be changed afterwards.",
    "open_url": "Open in new tab",
    "url_preview_label": "URL:",
    "url_preview_empty": "(will be based on the name)",
    "edit": "Edit",
    "delete": "Delete",
    "delete_confirm_title": "Delete category?",
    "delete_confirm_body": "This category is linked to {{count}} competitions. Deleting it will remove the category tag from these competitions, but the competitions themselves will remain. Do you want to continue?",
    "filter_label": "Filter by category",
    "filter_all_option": "All categories",
    "empty_state_for_category": "No competitions in category {{category}} in {{year}}.",
    "no_categories_yet": "No categories",
    "empty_state_help": "Categories let you group competitions so players can filter them in the event calendar.",
    "duplicate_name_error": "A category with this name already exists.",
    "duplicate_slug_error": "This URL slug is already in use.",
    "created_success": "Category created",
    "updated_success": "Category updated",
    "deleted_success": "Category deleted",
    "failed_to_load": "Failed to load categories",
    "failed_to_save": "Failed to save",
    "failed_to_delete": "Failed to delete"
  },
  "subCompetitions": {
    "tab_label": "Team Competition",
    "game_type_label": "Game Format",
    "best_ball": "Best Ball",
    "formation_label": "Team Formation",
    "formation_flight": "By Flight Group",
    "formation_club": "By Club",
    "formation_manual": "Manual",
    "counting_scores_label": "Scores per team",
    "team_column": "Team",
    "no_club": "No club",
    "resultTypes": {
      "STROKEPLAY_SCRATCH": "Stroke Play Scratch",
      "STROKEPLAY_HCP": "Stroke Play HCP",
      "STABLEFORD_SCRATCH": "Stableford Scratch",
      "STABLEFORD_HCP": "Stableford HCP",
      "MAXIMUMSCORE_SCRATCH": "Maximum Score Scratch",
      "MAXIMUMSCORE_HCP": "Maximum Score HCP",
      "SYSTEM36": "System 36"
    },
    "manual": {
      "load_failed": "Failed to load team data. Please try again.",
      "no_participants_heading": "No confirmed participants",
      "no_participants_body": "Teams cannot be formed because there are no confirmed participants yet.",
      "go_to_participants": "Go to participants →",
      "all_placed_heading": "All players placed",
      "all_placed_body": "Every participant belongs to a team. You can free a player by removing them from their team.",
      "col_player": "PLAYER",
      "col_club": "CLUB",
      "col_handicap": "HANDICAP",
      "form_team_button": "Form team →",
      "no_teams_heading": "No teams yet",
      "no_teams_body": "Select players from the left and press Form team. You can rename the team after forming it.",
      "default_team_name": "Team {{n}}",
      "rename_tooltip": "Rename",
      "delete_team_tooltip": "Delete team",
      "remove_player_tooltip": "Remove from team",
      "rename_placeholder": "Team name",
      "rename_save_tooltip": "Save name",
      "rename_cancel_tooltip": "Cancel rename",
      "edit_teams_button": "Edit teams",
      "teams_header": "TEAMS",
      "status_placed": "placed",
      "results_button": "Results",
      "formation_save_failed": "Saving the formation failed. Please try again.",
      "create_failed": "Creating the team failed. Please try again.",
      "rename_failed": "Renaming the team failed. Please try again.",
      "delete_failed": "Deleting the team failed. Please try again.",
      "remove_member_failed": "Removing the player failed. Please try again.",
      "confirm_delete_title": "Delete team",
      "confirm_delete_body": "This will delete the team and affect the scores. Do you want to continue?",
      "confirm_remove_title": "Remove player from team",
      "confirm_remove_body": "This will remove the player from the team and affect the scores. Do you want to continue?"
    }
  },
  "remove_theme_color": "Remove theme color"
}
